<template>
  <div class="bordered-group vs-card vs-con-block mt-5">
    <div class="vs-card-content">
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table max-items="10" :data="paymentRounds">
            <template slot="header">
              <div class="vx-row  w-full mb-1 mr-0 ml-0 p-0">
                <div class="vx-col w-1/2">
                  <h6>ข้อมูลแผนการชำระ</h6>
                </div>
                <div class="vx-col w-1/2 flex justify-end m-0 p-0">
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-plus"
                             @click="onPressedAddPaymentRound()">เพิ่มข้อมูล
                  </vs-button>
                </div>
              </div>
            </template>

            <template slot="thead">
              <vs-th>#</vs-th>
              <vs-th>วันที่รอบชำระ</vs-th>
              <vs-th>ประเภทรอบชำระ</vs-th>
              <vs-th>ยอดเรียกเก็บ (กรณียอดแบ่งจ่าย)</vs-th>
              <vs-th>ดอกเบี้ย</vs-th>
              <vs-th>ยอดค้างชำระยอดเรียกเก็บ</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="row" :key="index" v-for="(row, index) in data">
                <vs-td>
                  {{ row.paymentRoundSeq }}
                </vs-td>
                <vs-td>
                  {{ row.paymentRoundDateLocalTh }}
                </vs-td>
                <vs-td>
                  {{ row.paymentRoundTypeName }}
                </vs-td>
                <vs-td class="text-right">
                  {{ row.paymentRoundAmount | numberFormat }} ({{ row.paymentRoundAmountRestructuring | numberFormat }})
                </vs-td>
                <vs-td class="text-right">
                  {{ row.paymentRoundInterest | numberFormat }}
                </vs-td>
                <vs-td class="text-right">
                  {{ row.paymentRoundBalance | numberFormat }}
                </vs-td>
                <vs-td>
                  <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                    <vx-tooltip text="ลบข้อมูลแผนการชำระ">
                      <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash"
                                 @click="onPressedDelPaymentRound(row.id, row.paymentRoundSeq)"
                                 v-if="visibilityDelete(row)"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>

    </div>
    <vs-popup
      :active.sync="paymentRoundModal.active"
      title="เพิ่มข้อมูลแผนการชำระ"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ invalid }">
          <div class="vx-row">
            <div class="vx-col w-1/6">
              <ValidationProvider name="จำนวนงวด" rules="required" v-slot="{ errors }">
                <label class="text-sm">จำนวนงวด*</label>
                <vs-input type="number" class="w-full" v-model="paymentRoundModal.paymentRoundPeriod"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/3">
              <ValidationProvider name="ประเภท" rules="required" v-slot="{ errors }">
                <label class="text-sm">ประเภท*</label>
                <vs-select v-model="paymentRoundModal.paymentRoundType" class="w-full select-large">
                  <vs-select-item :key="index" :value="item.value" :text="item.label"
                                  v-for="(item,index) in paymentRoundTypesOptions"/>
                </vs-select>
                <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/3">
              <ValidationProvider name="ยอดเรียกเก็บ" rules="required" v-slot="{ errors }">
                <label class="text-sm">ยอดเรียกเก็บ*</label>
                <vs-input type="number" class="w-full" v-model="paymentRoundModal.paymentRoundAmount"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-1/6">
              <ValidationProvider name="รอบพิเศษ" rules="" v-slot="{ errors }">
                <label class="text-sm">รอบพิเศษ</label>
                <vs-checkbox v-model="paymentRoundModal.paymentRoundExtra"></vs-checkbox>
                <span class="text-danger text-sm" v-show="errors[0]">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-textarea v-model="paymentRoundModal.paymentRoundRemark" rows="5"/>
            </div>
          </div>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptAddPaymentRound">บันทึก</vs-button>
        <vs-button color="danger" @click="paymentRoundModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import vSelect from 'vue-select';
import {createNamespacedHelpers, mapGetters} from "vuex";
import {IPaymentRoundType} from "@/constants/interface";
import {visibility} from "tailwindcss/lib/plugins";
import {isRoot as fncIsRoot} from "@/utils";

const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');

export default {
  name: 'PaymentRoundInfoTab',
  components: {
    Divider,
    vSelect,
  },
  data() {
    return {
      paymentRoundModal: {
        active: false,
        paymentRoundPeriod: 1,
        paymentRoundType: IPaymentRoundType.principle,
        paymentRoundExtra: false,
        paymentRoundAmount: 0,
        paymentRoundRemark: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      paymentRoundTypesOptions: "Master/paymentRoundTypesOptions",
    }),
    ...mapAccountingFields(['contractDetailPaymentRounds']),
    isRoot () {
      return fncIsRoot();
    },
    paymentRounds() {
      if (!this.contractDetailPaymentRounds) return [];
      return this.contractDetailPaymentRounds.map((paymentRound) => {
        const {
          id,
          paymentRoundSeq,
          paymentRoundInterest,
          paymentRoundBalance,
          paymentRoundAmount,
          paymentRoundAmountRestructuring,
          paymentRoundDateLocalTh,
          paymentRoundTypeName,
          isNextMonth
        } = paymentRound;
        return {
          id,
          paymentRoundSeq,
          paymentRoundInterest,
          paymentRoundBalance,
          paymentRoundAmount,
          paymentRoundAmountRestructuring,
          paymentRoundDateLocalTh,
          paymentRoundTypeName,
          isNextMonth
        }
      })
    },
  },
  methods: {
    visibility() {
      return visibility
    },
    visibilityDelete(row) {
      return (row.isNextMonth || this.isRoot ) && row.paymentRoundInterest <= 0 && row.paymentRoundBalance <= 0
    },
    ...mapAccountingActions(['getContractDetail', 'createContractDetailPaymentRounds', 'deleteContractDetailPaymentRounds']),
    async onPressedAddPaymentRound() {
      this.paymentRoundModal.active = true
    },
    async onPressedAcceptAddPaymentRound() {
      const vm = this
      const contractId = this.$route.params.id;
      const {createContractDetailPaymentRounds} = vm;
      await createContractDetailPaymentRounds({
        contractId,
        form: {
          paymentRoundPeriod: parseInt(vm.paymentRoundModal.paymentRoundPeriod),
          paymentRoundType: vm.paymentRoundModal.paymentRoundType,
          paymentRoundExtra: vm.paymentRoundModal.paymentRoundExtra,
          paymentRoundAmount: parseFloat(vm.paymentRoundModal.paymentRoundAmount),
          paymentRoundRemark: vm.paymentRoundModal.paymentRoundRemark,
        }
      });
      vm.paymentRoundModal.active = false;
      vm.paymentRoundModal.paymentRoundPeriod = 1;
      vm.paymentRoundModal.paymentRoundType = IPaymentRoundType.principle;
      vm.paymentRoundModal.paymentRoundExtra = false;
      vm.paymentRoundModal.paymentRoundAmount = 0;
      vm.paymentRoundModal.paymentRoundRemark = '';
    },
    async onPressedDelPaymentRound(id, seq) {
      const vm = this
      const {deleteContractDetailPaymentRounds} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'ยืนยันการลบข้อมูล',
        text: 'คุณต้องการลบข้อมูลใช่หรือไม่? โดยจะลบข้อมูลทั้งหมดตั้งแต่รอบที่ ' + seq + ' เป็นต้นไป',
        acceptText: 'ใช่',
        accept: async () => {
          await deleteContractDetailPaymentRounds({
            id,
            vm
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.custom-popup .vs-popup {
  width: 600px;
}

.popup-content {
  padding: 10px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
